<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	name: 'Author Name',
	title: 'Prof.',
	image: '/webclip.png',
	bio: 'Author biography.',
	link: '/author/author-name',
}
const schema = defineSchema({
	name: $.text('Name'),
	title: $.text('Title'),
	image: $.upload('Image'),
	bio: $.richtext('Bio', { basic: true }),
	link: $.text('Link'),
})
export const AuthorPanoramic = defineBlock({ pickerHidden: true,
	thumbnail: '/block-thumbs/AuthorPanoramic.svg',
	category: 'Content',
	order: 60,
	name: 'AuthorPanoramic',
	label: 'Author Panoramic',
	icon: 'account_circle',
	schema,
	defaults,
})
</script>
<script setup lang="ts">

import { Image } from '@bagelink/vue'
import { computed } from 'vue'
import { displayImage } from '@/utils/image'

interface AuthorObj {
	name?: string
	title?: string
	image?: string
	bio?: string
	link?: string
}




// `author` is an object convenience prop used by list callers (BlockAllAuthors).
const props = defineProps<{
	name?: string
	title?: string
	image?: string
	bio?: string
	link?: string
	author?: AuthorObj
}>()

const name = computed(() => props.name ?? props.author?.name ?? '')
const title = computed(() => props.title ?? props.author?.title ?? '')
const image = computed(() => props.image ?? props.author?.image ?? '/webclip.png')
const link = computed(() => props.link ?? props.author?.link ?? '/')
const label = computed(() => [title.value, name.value].filter(Boolean).join(' '))
</script>

<template>
	<router-link :to="link || '/'" class="author-panoramic-item relative p-075" :title="label">
		<Image
			:src="displayImage(image, 'thumb')"
			:alt="name"
			ratio="1"
			class="aspect-ratio-1 cover round author-panoramic-img"
			lazy
		/>
		<div class="author-panoramic-info absolute transition">
			<Image
				:src="displayImage(image, 'thumb')"
				:alt="name"
				ratio="1"
				class="aspect-ratio-1 cover round author-panoramic-img mx-auto"
				lazy
			/>
			<p class="author-panoramic-name pt-05">
				{{ label }}
			</p>
		</div>
	</router-link>
</template>

<style>
.author-panoramic-item .author-panoramic-img {
	width: 54px;
	height: 54px;
}
.author-panoramic-item:hover .author-panoramic-info {
	opacity: 1;
	z-index: 99;
	scale: 1.1;
}
.author-panoramic-info {
	top: 8px;
	inset-inline-start: -40px;
	background: var(--bgl-gray);
	padding: 0.25rem;
	opacity: 0;
	width: 160px;
	text-align: center;
	transform-origin: center;
}
</style>
